Array.prototype.sort_attorneys = function()
{
	return this.sort(function(a, b){
		var a_text = a.innerHTML.toUpperCase();
		var b_text = b.innerHTML.toUpperCase();
		if(a_text > b_text)
		{
			return 1;
		}
		else if(a_text < b_text)
		{
			return -1;
		}
		else
		{
			return 0;
		}
	});
}
